import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/en';

export const DEFAULT_TIMEZONE = 'America/New_York';
const DEFAULT_LOCALES = 'en-US';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale(DEFAULT_LOCALES);

export const getDateInEST = (dt) => {
  const temp = dt.toLocaleString(DEFAULT_LOCALES, { timeZone: DEFAULT_TIMEZONE });
  return new Date(temp);
};

export const getEpochTime = (date, timeZone = DEFAULT_TIMEZONE) => dayjs.tz(date, timeZone).toISOString();
